import creator from './helpers/creator'
import device from './helpers/device'
import Menu from './modules/Menu'
import Newsletter from './modules/Newsletter'
import AnimateOnScroll from './modules/AnimateOnScroll'
import SimpleSelect from './modules/Select'
import Form from './modules/Form'
import StickyHeader from './modules/StickyHeader'
import Preload from './modules/Preload'
import Filter from './modules/Filter'
import LazyLoadModule from './modules/LazyLoad'
import YouTubePlayer from './modules/YouTubePlayer'
import CustomSlider from './modules/CustomSlider'
import Slider from './modules/Slider'
import ProjectFilter from './modules/ProjectFilter'
import PressScroll from './modules/PressScroll'
import Loadmore from './modules/Loadmore'
import AppHeight from './modules/AppHeight'
import Rotate from './modules/Rotate'
// import Tac from './modules/Tac'

import barba from '@barba/core';
import barbaCss from '@barba/css';
document.addEventListener("DOMContentLoaded", () => {
  if(document.body.classList.contains('home')) {
    window.preload = new Preload()
  }
  // window.tac = new Tac()
  window.appheight = new AppHeight()
  window.rotate = new Rotate()
  window.lazyload = new LazyLoadModule()
  window.newsletter = new Newsletter()
  window.animate = new AnimateOnScroll()
  window.customselect = new SimpleSelect()
  window.header = new StickyHeader()
  window.form = new Form()
  window.filter = new Filter()
  window.video = creator('.js-video', YouTubePlayer)
  window.menu = new Menu()
  window.projects = new ProjectFilter()
  window.slider = new Slider()
  window.loadmore = new Loadmore()
  if(window.matchMedia( "(min-width: 1024px)" ).matches) {
    window.press = new PressScroll()
  }
  if (device.isSafari) {
    document.body.classList.add('is-safari')
  }
});

const reload = () => {
  window.customslider = new CustomSlider()
  if(document.body.classList.contains('home')) {
    document.querySelector('.home-index').classList.add('animated')
    window.customslider.changeSlide(0)
    window.customslider.updateActiveDot(0)
    window.customslider.autoplay.timeInterval = 1000
  }
  window.rotate = new Rotate()
  window.lazyload = new LazyLoadModule()
  window.newsletter = new Newsletter()
  window.animate = new AnimateOnScroll()
  window.customselect = new SimpleSelect()
  window.header = new StickyHeader()
  window.form = new Form()
  window.filter = new Filter()
  window.video = creator('.js-video', YouTubePlayer)
  window.menu = new Menu()
  window.menu.close()
  window.slider = new Slider()
  window.loadmore = new Loadmore()
  if(window.matchMedia( "(min-width: 1024px)" ).matches) {
    window.press = new PressScroll()
  }
  if (device.isSafari) {
    document.body.classList.add('is-safari')
  }
}

barba.use(barbaCss);
barba.init()

barba.hooks.beforeEnter((data) => {
  window.scrollTo(0, 100)
  reload()
});

barba.hooks.afterLeave(data => {  
  let nextHtml = data.next.html
  let regexp = /\<body.*\sclass=["'](.+?)["'].*\>/gi, match = regexp.exec(nextHtml)
  if(!match || !match[1]) return
  document.body.setAttribute('class', match[1])
})

